module.exports = __webpack_public_path__ + "static/media/4.3e563889.svg";